import { BaseSocketEvent } from '/@/modules/core/app/events/BaseSocketEvent';
import { ModelType } from '/@/modules/core/app/constants/ModelType';

/**
 * @abstract
 */
export class UserSocketEvent extends BaseSocketEvent {
  static getChannelName(authUser, identifier) {
    return `${ModelType.USER}.${authUser.id}`;
  }
}
